import { render } from "./KeySignatureSelectComponent.vue?vue&type=template&id=489bcc08&scoped=true"
import script from "./KeySignatureSelectComponent.vue?vue&type=script&lang=js"
export * from "./KeySignatureSelectComponent.vue?vue&type=script&lang=js"

import "./KeySignatureSelectComponent.vue?vue&type=style&index=0&id=489bcc08&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489bcc08"]])

export default __exports__